import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="course"
export default class extends Controller {
  connect() {
    if (window.location.hash) {
      setTimeout(() => {
        this.travel({
          target: { hash: window.location.hash },
        });
      });
    }
  }

  travel(event) {
    try {
      const classController = document.querySelector(
        event.target.hash
      ).course_class;
      classController.reveal(event.target.hash);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (_) {
      setTimeout(() => {
        this.travel({
          target: { hash: event.target.hash },
        });
      }, 50);
    }
  }
}
